export function getEfacilUrl(): string {
  const env = process.env.NEXT_PUBLIC_ENV;
  if (process.env.NEXT_PUBLIC_EFACIL_URL) {
    return process.env.NEXT_PUBLIC_EFACIL_URL;
  }
  switch (env) {
    case 'local':
      return 'http://localhost:3001/';
    case 'development':
      return 'https://que6kehvig.us-east-1.awsapprunner.com/';
    case 'staging':
      return 'https://w68cukipgm.us-east-1.awsapprunner.com/';
    case 'production':
      return 'https://gcgm3pyghi.us-east-1.awsapprunner.com/';
    default:
      return 'https://que6kehvig.us-east-1.awsapprunner.com/';
  }
}
